import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { observer } from 'mobx-react';
import Button from '../../../components/Button';
import ListButton from '../../../components/ListButton';
import Icon from '../../../components/Icon';
import styles from './AddBillingMethodButton.m.sass';
var AddBillingMethodButton = function AddBillingMethodButton(props) {
  return props.checkout ? /*#__PURE__*/React.createElement(Button, {
    className: styles.button,
    outline: true,
    borderless: true,
    type: "primary",
    iconLeft: /*#__PURE__*/React.createElement(Icon, {
      auto: true,
      material: true,
      name: "credit card"
    }),
    disabled: props.disabled,
    onClick: props.onClick
  }, "Add Payment Method") : /*#__PURE__*/React.createElement(ListButton, _extends({
    icon: /*#__PURE__*/React.createElement(Icon, {
      auto: true,
      material: true,
      name: "credit card"
    })
  }, props), "Add Payment Method");
};
export default observer(AddBillingMethodButton);
//# sourceMappingURL=index.js.map
